/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Patients/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Patients({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Patients",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Patients.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-ZTNSgu': alignSelf,'--mt-2-ZTNSgu': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZTNSgu': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZTNSgu': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZTNSgu': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZTNSgu': opacity,'--w-10-ZTNSgu': typeof width === 'number' ? `${width}px` : width,'--h-11-ZTNSgu': typeof height === 'number' ? `${height}px` : height,'--f-12-ZTNSgu': fill,'--a-7-ZTNSgu': isAnimated ? animation : "none",'--sd-8-ZTNSgu': isAnimated ? strokeDashoffset : 0,'--sd-9-ZTNSgu': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Patients.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M19.557 19.84a7.86 7.86 0 00-15.114 0c.037.011.076.017.117.017h14.88c.04 0 .08-.006.117-.016zM4.56 2A2.56 2.56 0 002 4.56v14.88A2.56 2.56 0 004.56 22h14.88A2.56 2.56 0 0022 19.44V4.56A2.56 2.56 0 0019.44 2H4.56zM12 12.714a3.571 3.571 0 100-7.143 3.571 3.571 0 000 7.143z"
 style={{'--f-12-ZTNSgu': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}